<template>
  <div>
    <setting-header />
    <v-tabs
      v-model="tabs"
      height="26px"
      centered
      dense
      :hide-slider="true"
      class="settingHistory_tabs"
      active-class="settingHistory_tabs-active"
    >
      <v-tab v-for="(item, index) in tabItems" :key="index" :to="item.to">
        {{ item.label }}
      </v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SettingHeader from '../SettingHeader.vue';

export default {
  name: 'SettingHistory',
  components: {
    SettingHeader,
  },
  data() {
    return {
      tabs: null,
      tabItems: [
        {
          label: 'アプリ操作履歴',
          to: { name: 'settings-history-operation' },
        },
        {
          label: 'イベント履歴',
          to: { name: 'settings-history-event' },
        },
        {
          label: 'システム履歴',
          to: { name: 'settings-history-system' },
        },
      ],
    };
  },
  beforeDestroy() {
    this.setHistorySelectedGroup('');
    this.setHistoryDatesChecked(false);
    this.setHistoryDates([]);
  },
  methods: {
    ...mapActions('log', [
      'setHistoryDates',
      'setHistoryDatesChecked',
      'setHistorySelectedGroup',
    ]),
  },
};
</script>

<style lang="scss">
.settingHistory {
  &_tabs {
    width: 347px;
    margin: 17px 0;

    .v-slide-group__content.v-tabs-bar__content {
      border-radius: 5px;
      background-color: #eee;
      padding: 2px 0;
    }
    .v-tab {
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.54;
      letter-spacing: normal;
      text-align: left;
    }
    &-active {
      border-radius: 5px;
      background-color: #fff;
      color: #0075c2;
    }
  }
}
</style>
